import React from 'react';
import Column from './Column';
import Input from './Input';
import Button from './Button';
import Select, { Option } from './Select';
import Checkbox from './Checkbox';
import Switch from './Switch';
import InputPassword from './InputPassword';

const Form = ({ children, className, ...props }) => (
    <form
        className={className}
        { ...props }
    >
        {children}
    </form>
);

Form.Column = Column;
Form.Input = Input;
Form.Button = Button;
Form.Select = Select;
Form.Option = Option;
Form.Checkbox = Checkbox;
Form.Switch = Switch;
Form.InputPassword = InputPassword;

export { default as useForm, FORM_VALIDATORS } from './useForm';

export default Form;
